/**
 * Die Kisten-Sprache des Kiosks — eine Stelle für alle, die davon reden.
 *
 * 2026-09-26 (Owner): Die Festmengen für die Entnahme aus dem Vereinskühlhaus. Die Abteilungen
 * holen dort Kisten ab und lagern sie in die eigenen Kühlschränke um; bisher wurde das auf der
 * letzten verbliebenen Papierliste dokumentiert.
 *
 * **Die Knöpfe zählen KISTEN, sie setzen keine Stückzahl** (Owner-Entscheidung, zweite Runde).
 * Die erste Fassung setzte stur 20 — richtig für eine 0,5-l-Bierkiste, falsch für eine
 * 0,33-l-Kiste (24) und für Limo (12), und geradezu gefährlich für den Artikel „Kiste Bier", der
 * selbst schon eine Kiste ist: „Kiste" plus diese Kachel wären 20 Kisten gewesen. Wie viele
 * Einheiten eine Kiste ergibt, weiß nur der Artikel — also wird erst beim Antippen der Kachel
 * gerechnet.
 *
 * Eigene Datei, weil `kistenText` sowohl der Knopf davor als auch der Bestätigungsbalken danach
 * braucht. Zwei Schreibweisen für dieselbe Menge („½ Kiste" hier, „0,5 Kisten" dort) lesen sich
 * wie zwei verschiedene Dinge — und aus einer Komponentendatei heraus geteilt, kostet es das
 * Fast-Refresh der Entwicklungsumgebung.
 */
export const KISTEN_VORGABEN = [0.5, 1] as const;

/** „0,5" statt „0.5" — und „1" ohne Nachkommastelle. */
export const kistenText = (k: number) =>
  k === 0.5 ? '½ Kiste' : `${k.toLocaleString('de-DE')} Kiste`;
